export default __webpack_public_path__ + "static/media/hand.e22aabd1.svg";